import React from 'react';
export const Footer = () => {
  return <footer style={{
    borderColor: '#76a0b4'
  }} className="text-center text-lg py-6 border-t" data-id="element-106">
      <p className="mb-2" style={{
      color: '#465866'
    }} data-id="element-107">
        © 2023 PawEase. All Rights Reserved.
      </p>
      <div className="flex justify-center space-x-4" data-id="element-108">
        <a href="https://pawease2.myshopify.com/products/pawease" style={{
        color: '#76a0b4'
      }} className="hover:opacity-80" data-id="element-109">
          Privacy Policy
        </a>
        <a href="https://pawease2.myshopify.com/products/pawease" style={{
        color: '#76a0b4'
      }} className="hover:opacity-80" data-id="element-110">
          Terms of Service
        </a>
        <a href="https://pawease2.myshopify.com/products/pawease" style={{
        color: '#76a0b4'
      }} className="hover:opacity-80" data-id="element-111">
          Contact Us
        </a>
      </div>
      <p className="mt-4 text-gray-500" data-id="element-112">
        *Individual results may vary. These testimonials are from actual
        customers.
      </p>
    </footer>;
};